export default __webpack_public_path__ + "static/Areas-comuns-960562b6e4e72867f48670ffb9f36393.jpg";